import Router from '../router/index.js';
import store from '@/store/index.js';
import LojaServices from '@/services/lojas.js';
import LoginBackend from '@/services/login_backend.js';

class Login {
  constructor() {
    this.loginBackend = LoginBackend;
  }

  usuarioLogado() {
    return store.getters.getUsuarioLogado;
  }

  async login(usuario, senha, token) {
    try {
      const response = await this.loginBackend.validarUsuario(usuario, senha, token);
      const dadosUsuario = response.dados_usuario

      localStorage.setItem('jwtToken', response.token_jwt);
      localStorage.setItem('id_empresa', dadosUsuario.id_empresa);
      store.commit('login', dadosUsuario.id_usuario);
      localStorage.setItem("usuario", usuario);
  
      const estabelecimentos = dadosUsuario.estabelecimentos_completo;
  
      if (estabelecimentos.length === 1) {
        const lojas = await LojaServices.get({ 
          num_cnpj: estabelecimentos[0].CnpjEstabelecimento.replace(/\D/g, '') 
        });
        
        this.$alimentaDadosDoUsuario(
          usuario, 
          dadosUsuario.permissoes.pesquisa,
          dadosUsuario.permissoes.parametros,
          dadosUsuario.permissoes.etiquetas,
          dadosUsuario,
          lojas
        );
      } else if (estabelecimentos.length === 0) {
        throw new Error("Usuário sem loja vinculada");
      } else {
        this.$alimentaDadosDoUsuario(
          usuario,
          dadosUsuario.permissoes.pesquisa,
          dadosUsuario.permissoes.parametros,
          dadosUsuario.permissoes.etiquetas,
          dadosUsuario,
          dadosUsuario.estabelecimentos_completo
        );
      }

      return "Login realizado com sucesso!";
  
    } catch (error) {
      console.log("Erro durante o login: ", error)
      if (error.response?.status == 401) {
        throw new Error("Acesso negado! Verifique se o usuário e senha estão corretos.")
      } else {
        const mensagemErro = error.response?.data?.error || error.message || "Erro desconhecido no login";
        throw new Error(mensagemErro);
      }
    }
  }

  $alimentaDadosDoUsuario(login, pesquisa, parametros, etiquetas, dadosUsuario, estabelecimento) {
    store.commit('defineDadosUsuario', {
      login,
      nome: dadosUsuario.nome,
      email: dadosUsuario.email,
      nivelAcesso: {
        pesquisa,
        parametros,
        etiquetas
      }
    });

    if (estabelecimento && estabelecimento.length > 1) {
      store.commit('defineLojasUsuario', estabelecimento);
    } else {
      store.commit('defineLojaSelecionada', estabelecimento.lojas[0]);
    }

    return true;
  }

  logout() {
    localStorage.setItem("jwtToken", "");
    localStorage.setItem("recaptchaToken", "");
    store.commit('logout');
    store.commit('limpaEstabelecimentos');
    Router.push('/login');
  }

  validarNivel(...nivel) {
    return () => {
      let permitido = false;
      nivel.forEach(element => {
        permitido = permitido || store.getters[`getNivel${element}`] > 0;
      });
      return permitido;
    };
  }
}

const login = new Login();

export default login;
